import { useLang } from '../../../i18n/LanguageContext';

const communityPosts = [
  {
    id: 1,
    avatar: 'https://public.readdy.ai/ai/img_res/d9da62aeb420b8e597fa670340879f1c.jpg',
    titleEn: 'Sharing My First Tarot Reading Experience',
    titleZh: '分享我的第一次塔罗解读体验',
    timeEn: '2 hours ago', timeZh: '2小时前',
    likes: 128, comments: 45,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=spiritual%20healer%20woman%20avatar%2C%20golden%20light%20aura%2C%20professional%20portrait&width=100&height=100&seq=community-avatar-002&orientation=squarish',
    titleEn: 'Energy Shifts After the Full Moon Ritual',
    titleZh: '满月仪式后的能量变化',
    timeEn: '5 hours ago', timeZh: '5小时前',
    likes: 96, comments: 32,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=mystical%20practitioner%20avatar%2C%20purple%20and%20gold%20theme%2C%20spiritual%20profile&width=100&height=100&seq=community-avatar-003&orientation=squarish',
    titleEn: 'My Amazing Crystal Healing Experience',
    titleZh: '我的水晶疗愈奇妙体验',
    timeEn: '1 day ago', timeZh: '1天前',
    likes: 215, comments: 67,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=spiritual%20woman%20avatar%20with%20celestial%20energy%2C%20mystical%20portrait&width=100&height=100&seq=community-avatar-004&orientation=squarish',
    titleEn: 'How My Birth Chart Reading Changed My Life',
    titleZh: '星盘解读如何改变了我的人生',
    timeEn: '2 days ago', timeZh: '2天前',
    likes: 183, comments: 54,
  },
];

export default function Community() {
  return null;
}